// extracted by mini-css-extract-plugin
export default {"load-more":"load-more-659a","top-left-tag":"top-left-tag-78c1","progress":"progress-4a87","rejected":"rejected-dbc2","navy":"navy-b7d4","image-text":"image-text-06e7"};